import { mediaClient, mediaUploadClient, Server } from '@wajeez-web/core/api-base';
import { Media_Microservice_URL } from '@wajeez-web/core/utils';

const media = new Server.Server_Media_Client(undefined, mediaClient);
const mediaUpload = new Server.Server_Media_Client(undefined, mediaUploadClient);

export async function getPublicMediaByIdAsync(id: string | null | undefined) {
  if (!id) return '';
  return `${Media_Microservice_URL}api/media/v1/Media/public/${id}`;
}
export function getPublicMediaById(id: string | null | undefined) {
  if (!id) return '';
  return `${Media_Microservice_URL}api/media/v1/Media/public/${id}`;
}

export function getMediaById(id: string) {
  return `${Media_Microservice_URL}api/media/v1/Media/${id}`;
}
export async function getMediaUrlByIdAsync(id: string) {
  const response = await media.media_signed_id_get_V1(id);

  return response.data ?? '';
}
export async function getMediaBlobById(id: string) {
  const response = await media.media_download_id_get_V1(id);

  return new Blob([response.data], {
    type: response.headers ? response?.headers['content-type'] : 'image/png',
  });
}
export async function uploadMedia(file: Server.FileParameter) {
  const response = await mediaUpload.media_media_post_V1(file);
  return response.data;
}

export async function uploadPublicMedia(file: Server.FileParameter) {
  console.log('uploadPublicMedia')
  const response = await mediaUpload.media_media_public_post_V1(file);
  return response.data;
}
export async function uploadSummary(file: Server.FileParameter) {
  const response = await mediaUpload.media_summary_post_V1(file);
  return response.data;
}

export interface UploadFileParameter {
  data: File;
  fileName: string;
}
export async function uploadLargeMedia(file: UploadFileParameter) {
  console.log(file);
  const response = await mediaUpload.media_uploadUrl_post_V1({
    fileName: file.fileName,
    contentType: file.data.type
  });

  const uploadUrl = response?.data?.mainUploadUrl;

  await uploadViaLink(uploadUrl, file);

  if (response?.data?.secondaryUploadUrl) {
    await uploadViaLink(response?.data?.secondaryUploadUrl, file);
  }

  const assertResponse = await mediaUpload.media_checkUploaded_post_V1({
    key: response?.data?.key,
    mainUploadUrl: response?.data?.mainUploadUrl,
    secondaryUploadUrl: response?.data?.secondaryUploadUrl
  })

  console.log(assertResponse)

  return assertResponse.data;
}
async function uploadViaLink(uploadUrl: string | undefined, file: UploadFileParameter) {
  if (!uploadUrl) {
    throw new Error('Failed to get upload url');
  }

  await fetch(uploadUrl, {
    method: 'PUT',
    body: file.data,
    headers: {
      'Content-Type': file.data.type
    }
  });
}

